import { useInfiniteQuery } from "@tanstack/react-query";
const { default: apiClient } = require("lib/api-client");

const fetchDesigns = async ({ pageParam = 1, queryKey }) => {
  const [
    ,
    {
      categoryName,
      subCategoryName,
      sortBy,
      order,
      searchTerm,
      limit,
      location,
      stockStatus,
      goldColor,
      goldQlty,
      diaQlty,
      designClass,
      isHidden,
      diamondPieces,
      diamondWeight,
      goldGrossWeight,
      goldNetWeight,
      ratio,
    },
  ] = queryKey;

  const response = await apiClient.post("/api/v1/stocks/getStockDetailsOfSubCategory", {
    categoryName,
    subCategoryName: subCategoryName === "Blank" ? "null" : subCategoryName,
    page: pageParam,
    limit,
    sortBy,
    order,
    searchTerm,
    location,
    stockStatus,
    goldColor,
    goldQlty,
    diaQlty,
    designClass,
    isHidden,
    diamondPieces,
    diamondWeight,
    goldGrossWeight,
    goldNetWeight,
    ratio,
  });

  if (response.status !== 200) {
    throw new Error("Error fetching categories");
  }

  return {
    stockDesigns: response.data.stocks,
    nextPage: response.data.pagination.page + 1,
    totalPages: response.data.pagination.totalPages,
    totalCount: response.data.totalStock,
    totalSerachAndFilter: response.data.totalSerachAndFilter,
  };
};

export const useStockDesings = ({
  categoryName = "",
  subCategoryName = "",
  sortBy = "Make Date",
  order = "desc",
  searchTerm = "",
  limit = 10,
  location = [],
  goldColor = [],
  goldQlty = [],
  diaQlty = [],
  designClass = [],
  stockStatus = "",
  isHidden,
  diamondPieces = "",
  diamondWeight = "",
  goldGrossWeight = "",
  goldNetWeight = "",
  ratio = "",
}) => {
  return useInfiniteQuery({
    queryKey: [
      "stockDesigns",
      {
        categoryName,
        subCategoryName,
        sortBy,
        order,
        searchTerm,
        limit,
        location,
        stockStatus,
        goldColor,
        goldQlty,
        diaQlty,
        designClass,
        isHidden,
        diamondPieces,
        diamondWeight,
        goldGrossWeight,
        goldNetWeight,
        ratio,
      },
    ],

    queryFn: ({ pageParam = 1 }) =>
      fetchDesigns({
        pageParam,
        queryKey: [
          "stockDesigns",
          {
            categoryName,
            subCategoryName,
            sortBy,
            order,
            searchTerm,
            limit,
            location,
            stockStatus,
            goldColor,
            goldQlty,
            diaQlty,
            designClass,
            isHidden,
            diamondPieces,
            diamondWeight,
            goldGrossWeight,
            goldNetWeight,
            ratio,
          },
        ],
      }),
    getNextPageParam: (lastPage) => {
      if (lastPage.nextPage <= lastPage.totalPages) {
        return lastPage.nextPage;
      }
      return undefined;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
